module.exports = __webpack_public_path__ + "static/media/customer-support.ad1cd519.svg";